import { Toast, ToastContainer } from '@glow/ui-components'
import { createContext, ReactElement, ReactNode, useCallback, useMemo, useState } from 'react'
import { ErrorResponse, errorResponseMessage } from '../utils/errorResponse'

interface ToastContextValue {
  // Show a Toast message at the bottom-center of the screen.
  setToast: (toast: Toast) => void
  // A helper for showing an Error object as a Toast message.
  setToastError: (err: unknown) => void
}

/** Kept as the name callers already import; the shape lives with the message helper. */
export type ErrorResponseToast = ErrorResponse

export const ToastContext = createContext<ToastContextValue>({
  setToast: setToastPlaceholder,
  setToastError: setToastErrorPlaceholder
})

export function ToastProvider(props: { children: ReactNode }): ReactElement | null {
  const [state, setToast] = useState<Toast>()

  const setToastError = useCallback((err: unknown) => {
    setToast({ variant: 'error-dark', text: errorResponseMessage(err) })
  }, [])

  const value = useMemo(
    () => ({
      setToast,
      setToastError
    }),
    [setToastError]
  )

  return (
    <ToastContext.Provider value={value}>
      {props.children}
      <ToastContainer toast={state} />
    </ToastContext.Provider>
  )
}

function setToastPlaceholder() {
  throw new Error('setToast used outside ToastProvider')
}

function setToastErrorPlaceholder() {
  throw new Error('setToastError used outside ToastProvider')
}
